import $C from "@/consts/index";
import $api from '@/apiProvider';
import XLSX from "xlsx";
import ChooseOrderTwo from '@/components/modal/ChooseInvoiceOrder'
import ChooseRelationOrder from '@/components/modal/ChooseRelationOrder'
import UploadList from '@/components/common/UploadList'
import Account from '@/components/modal/Account'
import PlatformCorp from '@/components/common/PlatformCorp'
import ChooseCarShip from '@/components/modal/ChooseCarShip'
import TableHeader from '@/components/common/TableHeader'
import SalesMan from '@/components/common/SalesMan'
import DetailHeader from "@/views/procedure/DetailHeader";
import Import from "@/components/common/Import"; // 
import auth from "@/utils/auth";
import {
  invoiceFooter,
  getExcelTime,
  showLoading,
  hideLoading,
  showFailMsgList,
  isNotEmpty,
  isEmpty
} from '@/utils/util'
import getAuthOrization from "@/mixin/getAuthOrization";

const assign = (o) => Object.assign({}, o)
const empties = [undefined, '', null, 'null', {},
  []
]

export default {
  mixins: [getAuthOrization],
  name: 'CreateInvoice',
  components: {
    SalesMan,
    TableHeader,
    PlatformCorp,
    ChooseOrderTwo,
    ChooseRelationOrder,
    UploadList,
    ChooseAccount: Account,
    ChooseCarShip,
    DetailHeader,
    Import
  },
  props: {
    cate: {
      type: String, // Sales, Income
      default: ''
    },
    isShow: {
      type: Boolean,
      default: false
    },
    isImport: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let userInfoValue = {};
    if (auth.isLogin()) {
      userInfoValue = auth.getAuth();
    }
    return {
      userInfoValue,
      isSalesMan: false,
      canInsert: true,
      dicByParentData: [], //配置信息
      isShowChooseOrder: false,
      isShowChooseAccount: false,
      isShowChooseCarShip: false,
      invoiceType: $C.invoiceType.options,
      deductType: $C.deductType.options,
      currentChooseColumn: '',
      dataTmp: {
        "index": 1,
        "addTime": null,
        "deductTime": null, // 抵扣日期 进项发票
        "amount": null,
        "beginPlace": null,
        "carShipNum": null,
        "compName": null,
        "endPlace": null,
        "fileUuidList": [],
        "fileList": [],
        "goodsName": null,
        "counts": null,
        "price": null,
        "unit": null,
        "taxAmount": null,
        "taxRate": 9,
        "invoiceNum": null,
        "invoiceCompName": null,
        "invoiceTitle": null,
        "invoiceType": 2,
        "laydays": null,
        "linkMan": null,
        "logisticsComp": null,
        "logisticsNum": null,
        "note": null,
        "ordersBuyerId": null,
        "ordersSellerId": null,
        "orderNum": null,
        "salesMan": null,
        "rateManage": null,
        "manageAmount": null,
        "totalAmount": null,
        "deductType": null, // 抵扣方式 进项发票
        "rateDeduct": null,
        "orderRateDeduct": null,
        "orderRateDeductManage": null,
        "taxTotalAmount": null
      },
      tableData: [],
      editRules: {
        // "salesMan": [{
        //   validator: this.requireValid
        // }],
        "invoiceNum": [{
          validator: this.requireValid
        }],
        "addTime": [{
          validator: this.requireValid
        }],
        "deductTime": [{
          validator: this.requireValid
        }],
        "invoiceType": [{
          validator: this.requireValid
        }],
        "invoiceCompName": [{
          validator: this.requireValid
        }],
        "invoiceTitle": [{
          validator: this.requireValid
        }],
        "goodsName": [{
          validator: this.requireValid
        }],
        // "counts": [{
        //   validator: this.requireValid
        // }],
        // "unit": [{
        //   validator: this.requireValid
        // }],
        "taxRate": [{
          validator: this.requireValid
        }],
        "taxAmount": [{
          validator: this.requireValid
        }],
        "amount": [{
          validator: this.requireValid
        }],
        "totalAmount": [{
          validator: this.requireValid
        }],
        "taxTotalAmount": [{
          validator: this.requireValid
        }],
        // "rateManage": [{
        //   validator: this.requireValid
        // }],
        // "deductType": [{
        //   validator: this.requireValid
        // }],
        // "rateDeduct": [{
        //   validator: this.requireValid
        // }],
        // "manageAmount": [{
        //   validator: this.requireValid
        // }]
      },
      formData: {},
      isSubmit: false,
      flowTempletId: 3,
      isLoaded: false,
      chainId: null,
      templateVisible: false,
      isCurImport: false,
      isinitByOrder: false,
      tax_rate: [],
    };
  },
  watch: {
    isShow: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val == false && oldVal == true) {
          this.$refs.xTable.clearValidate()
          this.tableData = []
          this.canInsert = true
          this.isSubmit = false;
          this.isLoaded = false;
          this.isCurImport = false;
          this.isinitByOrder = false
        }
        if (val == true) {
          this.tableData = [assign(this.dataTmp)]
          let id = this.cate === "Income" ? 4 : 3
          this.getFlowData(id)
        }
      }
    },
  },
  // beforeMount() {
  //   let id = this.cate === "Income" ? 4 : 3
  //   console.log(id, '111111');
  //   debugger
  //   this.getFlowData(id)
  //   // this.getDicByParentList()
  // },
  mounted() {
    this.getDictByCode(603, 'tax_rate');
  },
  methods: {
    change(row) {
      this.calcMoneyAll(row);
      this.$refs.xTable.clearValidate()
    },
    async getDictByCode(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map(i => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          })
        })
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    initByChainId(chainId) {
      this.chainId = chainId
      this.isinitByOrder = true
      // let orderInfo = this.getBuyerOrderInfoByChainId(chainId);
      // orderInfo.then(res => {
      //   if (null != res) {
      //     this.initByOrderInfo(res);
      //   }
      // })
    },
    getPayObj(val) {
      this.formData = val;
      // this.payType = val.type;
    },
    getFlowData(id) {
      let obj = {
        flowTempletId: id
      };
      this.flowTempletId = id;
      $api.flowInstance.createFlowModel
        .GET({
          params: obj,
        })
        .then((res) => {
          if (res.status === 1) {
            this.formData = res.data;
            this.isLoaded = true
          } else {
            this.$XModal.confirm(res.message).then(() => {
              this.$emit('close')
            })
          }
        });
    },
    getSaleManInfo(val) {
      let index = val.rowIndex
      this.currentRow = this.$refs.xTable.getTableData().tableData[index]
      this.currentRow.orderRateDeduct = null
      this.currentRow.orderRateDeductManage = null
      this.currentRow.rateManage = null
      this.currentRow.rateDeduct = null
      this.currentRow.deductType = null
      if (this.cate == 'Sales') {
        if (this.currentRow.invoiceCompName && val.rateList && val.rateList.length > 0) {
          let obj = val.rateList.filter(item => item.compName == this.currentRow.invoiceCompName)
          if (obj && obj.length > 0 && obj[0].rateManage) {
            this.currentRow.rateManage = obj[0].rateManage
          }
          // debugger
          this.calcMoneyTreAll(this.currentRow, 'rateManage')
        }
      } else {
        if (this.currentRow.invoiceTitle && val.rateList && val.rateList.length > 0) {
          let obj = val.rateList.filter(item => item.compName == this.currentRow.invoiceTitle)
          if (obj && obj.length > 0 && obj[0].rateManage) {
            this.currentRow.orderRateDeduct = obj[0].rateDeduct
            this.currentRow.orderRateDeductManage = obj[0].rateDeductManage
          }
        }
      }
    },
    async getInvoiceTitle(val, row) {
      if (val) {
        // let index = row.index - 1
        let index = row.index
        this.currentRow = this.$refs.xTable.getTableData().tableData[index]
        if (this.currentRow) {
          this.currentRow.rateDeduct = null
          this.currentRow.deductType = null
          this.currentRow.manageAmount = null
          if (this.userInfoValue.identityType !== 0) {
            //  登录不是业务员
            this.currentRow.salesMan = null
            this.currentRow.rateManage = null
          } else {
            // 登录是业务员
            let res = await $api.baseUserSales.request("querySalesDetail", {
              id: this.userInfoValue.id,
            });
            if (res.status === 1) {
              if (res.data && res.data.rateList) {
                let list = res.data.rateList
                let rowName = this.cate === 'Sales' ? this.currentRow.invoiceCompName : this.currentRow.invoiceTitle
                let obj = list.filter(item => item.compName == rowName)
                if (obj && obj.length > 0 && obj[0].rateManage) {
                  this.currentRow.rateManage = obj[0].rateManage
                  this.currentRow.orderRateDeduct = obj[0].rateDeduct
                  this.currentRow.orderRateDeductManage = obj[0].rateDeductManage
                  this.cate === 'Sales' ? this.calcMoneyTreAll(this.currentRow, 'rateManage') : ''
                } else {
                  this.currentRow.rateManage = null
                  this.currentRow.orderRateDeduct = null
                  this.currentRow.orderRateDeductManage = null
                }
              }
            } else {
              this.currentRow.rateManage = null
            }
          }
        }
      }
    },
    async getBuyerOrderInfoByChainId(chainId) {
      let orderInfo = null;
      let res = await $api.order.post("queryOrdersBuyerList", {
        chainId: chainId,
        page: 1,
      });
      if (res.status == 1 && res.data.rows.length > 0) {
        let orderRes = await $api.order.post("queryOrdersBuyerDetail", {
          id: res.data.rows[0].id,
        });
        if (orderRes.status == 1) {
          orderInfo = orderRes.data;
        }
      }
      return orderInfo;
    },
    initByOrderInfo(orderInfo) {
      console.log('创建发票 通过 订单号初始化', orderInfo)
      this.isinitByOrder = true
      this.chainId = orderInfo.chainId;
      this.insertEvent()
      this.currentRow = this.$refs.xTable.getTableData().tableData[0]
      // this.chooseOrderEvent(orderInfo)
      this.$refs.xTable.reloadData([this.currentRow])
      // this.canInsert = false
    },
    getDicByParentList() {
      $api.other.getDicByParentModel
        .GET({
          params: {
            page: 1,
            rows: 10,
          },
        })
        .then((res) => {
          this.dicByParentData = res.data;
        });
    },
    showTempModal() {
      if (this.cate == 'Sales') {
        this.$refs.modalTemplate.setExport('711销项发票信息导入模板.xls');
      } else {
        this.$refs.modalTemplate.setExport('710进项发票信息导入模板.xls');
      }
      this.templateVisible = true;
    },
    closeTemplate() {
      this.templateVisible = false;
    },
    goImport() {
      this.isShowCreateInvoice = true
      this.isCurImport = true;
      this.templateVisible = false;
    },
    async impotEvent() {
      this.$refs.xTable.readFile({
        types: ['xls', 'xlsx']
      }).then(evnt => {
        showLoading();
        const tableData = [];
        const importIds = []
        const files = evnt.target.files;
        const fileReader = new FileReader();
        fileReader.onload = async (ev) => {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: 'binary'
          });
          const csvData = XLSX.utils.sheet_to_csv(Object.values(workbook.Sheets)[0]);
          // 解析数据
          let xlsxData = csvData.split('\n');
          //删除xlsx列名
          xlsxData.splice(0, 1);
          xlsxData.forEach((vRow) => {
            if (vRow) {
              const vCols = vRow.split(',');
              if (isNotEmpty(vCols[1])) {
                importIds.push(vCols[1]);
              } else if (isNotEmpty(vCols[2])) {
                importIds.push(vCols[2]);
              }

              let item = {}
              let vColNum;
              if (isNotEmpty(vCols[1])) {
                vColNum = vCols[1].trim()
              } else if (isNotEmpty(vCols[2])) {
                vColNum = vCols[2].trim()
              } else {
                vColNum = null
              }
              if (this.cate == 'Sales') {
                // 销项
                item = {
                  index: vCols[0] ? vCols[0].trim() : null, //需要
                  orderNum: vColNum, //承运人订单号
                  ordersSellerNum: vCols[2] ? vCols[2].trim() : null,
                  ordersBuyerNum: vCols[1] ? vCols[1].trim() : null,
                  invoiceNum: vCols[3] ? vCols[3].trim() : null, //发票编号
                  addTime: vCols[4] ? getExcelTime(vCols[4].trim()) : null, //开票日期
                  invoiceType: vCols[5] ? (vCols[5].trim() == '增值税普通发票' ? 1 : 2) : null, //发票类型
                  invoiceCompName: vCols[6] ? vCols[6].trim() : null, //开票单位
                  invoiceTitle: vCols[7] ? vCols[7].trim() : null, //发票抬头
                  goodsName: vCols[8] ? vCols[8].trim() : null, //应税商品名称
                  unit: vCols[9] ? vCols[9].trim() : null, //单位
                  counts: vCols[10] ? vCols[10].trim() : null, //应税商品数量
                  price: vCols[11] ? vCols[11].trim() : null, //不含税单价（元）
                  totalAmount: vCols[12] ? vCols[12].trim() : null, //不含税金额
                  taxRate: !isEmpty(vCols[13]) ? parseFloat(vCols[13].trim()) : null, //税率（%）
                  taxAmount: vCols[14] ? vCols[14].trim() : null, //税额（元）
                  taxTotalAmount: vCols[15] ? vCols[15].trim() : null, //价税合计（元）
                  salesMan: vCols[16] ? vCols[16].trim() : null, //业务员
                  rateManage: !isEmpty(vCols[17]) ? parseFloat(vCols[17].trim()) : null, //费率
                  manageAmount: vCols[18] ? vCols[18].trim() : null, //管理费
                  carShipNum: vCols[19] ? vCols[19].trim() : null, //车船名
                  beginPlace: vCols[20] ? vCols[20].trim() : null, //起运地
                  endPlace: vCols[21] ? vCols[21].trim() : null, //到达地
                  laydays: vCols[22] ? getExcelTime(vCols[22].trim()) : null, //受载/交接日期
                  note: vCols[23] ? vCols[23].trim() : null, //备注
                  logisticsNum: vCols[24] ? vCols[24].trim() : null,
                  logisticsComp: vCols[25] ? vCols[25].trim() : null,
                  // amount: vCols[14], // 不传报错
                };
              } else {
                // 进项
                item = {
                  index: vCols[0] ? vCols[0].trim() : null, //需要
                  orderNum: vColNum, //承运人订单号
                  ordersSellerNumLv2: vCols[2] ? vCols[2].trim() : null,
                  ordersSellerNum: vCols[1] ? vCols[1].trim() : null,
                  invoiceNum: vCols[3] ? vCols[3].trim() : null, //发票编号
                  addTime: vCols[4] ? getExcelTime(vCols[4].trim()) : null, //开票日期
                  deductTime: vCols[5] ? getExcelTime(vCols[5].trim()) : null, //抵票日期
                  invoiceType: vCols[6] ? (vCols[6].trim() == '增值税普通发票' ? 1 : 2) : null, //发票类型
                  invoiceCompName: vCols[7] ? vCols[7].trim() : null, //开票单位
                  invoiceTitle: vCols[8] ? vCols[8].trim() : null, //发票抬头
                  goodsName: vCols[9] ? vCols[9].trim() : null, //应税商品名称
                  unit: vCols[10] ? vCols[10].trim() : null, //单位
                  counts: vCols[11] ? vCols[11].trim() : null, //应税商品数量
                  price: vCols[12] ? vCols[12].trim() : null, //不含税单价（元）
                  totalAmount: vCols[13] ? vCols[13].trim() : null, //不含税金额
                  taxRate: !isEmpty(vCols[14]) ? parseFloat(vCols[14].trim()) : null, //税率（%）
                  taxAmount: vCols[15] ? vCols[15].trim() : null, //税额（元）
                  taxTotalAmount: vCols[16] ? vCols[16].trim() : null, //价税合计（元）
                  salesMan: vCols[17] ? vCols[17].trim() : null, //业务员
                  // deductType: vCols[17] == '价税合计' ? 1 : 2, //抵扣方式
                  rateDeduct: !isEmpty(vCols[19]) ? parseFloat(vCols[19].trim()) : null, //抵扣比例
                  manageAmount: !isEmpty(vCols[20]) ? parseFloat(vCols[20].trim()) : null, //抵扣管理费
                  carShipNum: vCols[21] ? vCols[21].trim() : null, //车船名
                  beginPlace: vCols[22] ? vCols[22].trim() : null, //起运地
                  endPlace: vCols[23] ? vCols[23].trim() : null, //到达地
                  laydays: vCols[24] ? getExcelTime(vCols[24].trim()) : null, //受载/交接日期
                  note: vCols[25] ? vCols[25].trim() : null, //备注
                  // amount: vCols[15], // 不传报错
                };
                if (vCols[18] && vCols[18].trim() == '价税合计') {
                  item.deductType = 1
                } else if (vCols[18] && vCols[18].trim() == '增值税') {
                  item.deductType = 2
                } else {
                  item.deductType = null
                }
                // item.deductType: vCols[17] == '价税合计' ? 1 : 2, //抵扣方式
              }
              // console.log(this.taxTotalAmount);
              // debugger
              // if (!isEmpty(item.taxTotalAmount)) {
              //   debugger
              //   item.amount = item.taxTotalAmount
              // }
              // if (isEmpty(item.taxAmount) || isEmpty(item.amount)) {
              //   this.calcMoney(item, 'taxRate')
              // }
              // 是否需要查每个业务员ID
              // if (!isEmpty(item.salesMan)) {
              //   let salesManRed ;
              //   console.log(salesManRed);
              //   item.salesManId = item.taxTotalAmount
              // }
              if (this.cate == 'Sales') {
                if (!isEmpty(item.taxTotalAmount) && !isEmpty(item.rateManage) && isEmpty(item.manageAmount)) {
                  this.calcMoneyTreAll(item)
                }
              } else {
                if (!isEmpty(item.taxTotalAmount) && !isEmpty(item.rateDeduct) && isEmpty(item.manageAmount)) {
                  this.calcMoneyTreAll(item)
                }
              }

              tableData.push(item);
            }
          })
          let res;
          if (this.cate == 'Sales') {
            res = await $api.ordersBuyer.post('queryOrdersBuyerSalesInfoList', importIds)
          } else {
            res = await $api.ordersSeller.post('queryOrdersSellerSalesInfoList', importIds)
          }
          if (res.status == 1) {
            let orders = res.data;
            tableData.map(i => {
              if (i.orderNum) {
                let orderInfo = orders.find(j => j.ordersNum === i.orderNum);
                if (isNotEmpty(orderInfo)) {
                  if (this.cate == 'Sales') {
                    // i.ordersBuyerId = orderInfo.ordersId;
                    // && i.invoiceCompName == orderInfo.compName
                    if (isEmpty(i.rateManage)) {
                      i.rateManage = orderInfo.rateManage
                    }
                    if (isEmpty(i.manageAmount)) {
                      this.calcMoneyTreAll(i)
                    }
                  } else {
                    // i.ordersSellerId = orderInfo.ordersId
                    if (isEmpty(i.rateDeduct)) {
                      i.rateDeduct = i.deductType == 1 ? orderInfo.rateDeduct : orderInfo.rateDeductManage
                    }
                    if (isEmpty(i.manageAmount)) {
                      this.calcMoneyTreAll(i)
                    }
                  }
                  i.compName = orderInfo.compName ? orderInfo.compName : '';
                  // i.salesMan = orderInfo.salesMan ? orderInfo.salesMan : ''
                  // i.salesManId = orderInfo.salesManId ? orderInfo.salesManId : ''
                  // i.isOrderSalesMan = true
                }
              }
            })
            this.tableData = tableData;
            this.updateFooterEvent();
          } else {
            this.$XModal.alert({
              message: res.message ? res.message : "接口异常",
              status: "error",
            });
          }
          setTimeout(() => {
            hideLoading();
          }, 1000);
        }
        fileReader.readAsBinaryString(files[0]);
      })
    },
    async requireValid(e) {

      // if (e.columnIndex == 2) {
      //   if (this.isImport && isEmpty(e.row.orderNum)) {
      //     return Promise.reject(new Error('导入必须填写订单号'))
      //   }
      // } else if (empties.includes(e.cellValue)) {
      //   return Promise.reject(new Error(e.column.title + '必填'))
      // }
      // console.log(e.column.title, 'e.row');
      if (e.column.title == '发票编号' && isNotEmpty(e.row.invoiceNum)) {
        let rep = /^(\d{8})?$/
        let invoiceNum = e.row.invoiceNum.trim()
        if (!rep.test(invoiceNum)) {
          return Promise.reject(new Error('请输入正确的发票号码'))
        }
      }
      if (this.cate === "Income" && e.column.title == '抵扣日期' && isEmpty(e.row.deductTime)) {
        return Promise.reject(new Error('抵扣日期不能为空'))
      }
      // if (this.cate === 'Sales' && e.column.title == '管理费' && isEmpty(e.row.manageAmount)) {
      //   return Promise.reject(new Error('管理费不能为空'))
      // }
      // if (empties.includes(e.cellValue) && e.column.title !== '抵扣管理费') {
      //   return Promise.reject(new Error(e.column.title + '必填'))
      // }
      if (empties.includes(e.cellValue)) {
        return Promise.reject(new Error(e.column.title + '必填'))
      }
    },
    cellClickEvent(e) {
      let col = e.column.property
      switch (col) {
        case 'orderNum':
          if (this.canInsert) {
            this.currentRow = e.row
            this.isShowChooseOrder = true
            this.$refs.chooseOrder.init(this.cate)
          }
          break;
      }
      this.$refs.xTable.clearValidate()
    },
    changeInvoiceType(row) {
      console.log('changeInvoiceType', row)
    },
    changeDeductType(index) {
      // 1: 价税合计， 2：增值税
      this.currentRow = this.$refs.xTable.getTableData().tableData[index]
      this.currentRow.rateDeduct = this.currentRow.deductType === 1 ? this.currentRow.orderRateDeduct : this.currentRow.orderRateDeductManage;
      this.calcMoneyTreAll(this.currentRow, 'rateDeduct')
    },
    async chooseOrderEvent(order) {
      // 会带入，开票单位、发票抬头、应税商品名称、数量、单位
      console.log('chooseOrderEvent', order)
      if (this.cate == 'Sales') {
        // 开票
        if (order.orderType === 1) {
          this.currentRow.ordersBuyerId = order.id;
          this.currentRow.orderNum = order.buyerOrdersNum;
          this.currentRow.invoiceCompName = order.sellerName
          this.currentRow.platformCompanyId = order.platformCompanyId
          this.currentRow.invoiceTitle = order.buyerName
        } else {
          this.currentRow.ordersSellerId = order.id;
          this.currentRow.orderNum = order.sellerOrdersNum;
          this.currentRow.invoiceCompName = order.sellerName
          this.currentRow.platformCompanyId = order.platformCompanyId
          this.currentRow.invoiceTitle = order.platformCompany
        }
      } else {
        // 抵扣票
        if (order.orderType === 2) {
          this.currentRow.ordersSellerId = order.id
          this.currentRow.orderNum = order.sellerOrdersNum
          this.currentRow.invoiceCompName = order.sellerName
          this.currentRow.platformCompanyId = order.platformCompanyId
          this.currentRow.invoiceTitle = order.buyerName
        } else {
          this.currentRow.ordersSellerIdLv2 = order.id
          this.currentRow.orderNum = order.sellerOrdersNum
          this.currentRow.invoiceCompName = order.sellerName
          this.currentRow.platformCompanyId = order.platformCompanyId
          this.currentRow.invoiceTitle = order.buyerName
        }
        // this.currentRow.ordersSellerId = order.id
        // this.currentRow.orderNum = order.sellerOrdersNum
      }
      // this.currentRow.invoiceCompName = order.sellerName
      // this.currentRow.platformCompanyId = order.platformCompanyId
      // this.currentRow.invoiceTitle = order.buyerName

      if (!empties.includes(order.goodsRtnVos) && order.goodsRtnVos.length > 0) {
        this.currentRow.goodsName = order.goodsRtnVos[0].goodsName
        this.currentRow.counts = order.goodsRtnVos[0].counts
        this.currentRow.unit = order.goodsRtnVos[0].unit
      }
      // if (isNotEmpty(order.sellerName)) {
      //   this.currentRow.isOrderInvoiceCompName = true
      // }
      // if (isNotEmpty(order.buyerName)) {
      //   this.currentRow.isOrderInvoiceTitle = true
      // }

      if (isNotEmpty(order.salesMan) && isEmpty(this.currentRow.salesMan)) {
        this.currentRow.salesMan = order.salesManName
        this.currentRow.salesManId = order.salesMan
        this.currentRow.rateManage = order.rateManage
        // if (order.rateManage && order.rateManage !== 0 && order.rateManage !== '') {
        //   this.currentRow.manageAmount =  (order.rateManage / 100 ) * this.currentRow.taxTotalAmount
        // }

        // this.currentRow.isOrderSalesMan = true
        // 选择订单
        let res = await $api.baseUserSales.request("querySalesDetail", {
          id: order.salesMan,
          compName: this.currentRow.invoiceTitle
        });
        if (res.status === 1) {
          if (res.data.rateList && res.data.rateList.length === 1) {
            this.currentRow.orderRateDeduct = res.data.rateList[0].rateDeduct
            this.currentRow.orderRateDeductManage = res.data.rateList[0].rateDeductManage
          }
        }

        this.$refs.xTable.updateStatus()
      }
      // this.currentRow.rateManage = order.rateManage

      this.isShowChooseOrder = false

      this.$refs.xTable.clearValidate('orderNum')
      this.updateFooterEvent()
    },
    openChooseAccount(row, field) {
      this.isShowChooseAccount = true
      this.currentRow = row
      this.currentChooseColumn = field
      this.$refs.chooseAccount.init()
    },
    chooseAccountEvent(account, type) {
      console.log('chooseAccountEvent', account)
      //选择开票单位 使用用户名
      // this.currentRow[this.currentChooseColumn] = type === 1 ? account.compName : account.realName;
      this.currentRow[this.currentChooseColumn] = account.userName
      this.isShowChooseAccount = false
      this.$refs.xTable.clearValidate(this.currentChooseColumn)
    },
    showChooseCarShip(row) {
      this.currentRow = row
      this.isShowChooseCarShip = true
      this.$refs.chooseCarShip.init()
    },
    chooseCarShip(data, cate) {
      this.currentRow.carShipNum = (cate == 'car' ? data.carNum : data.shipName)
      this.isShowChooseCarShip = false
    },
    insertEvent() {
      let tableData = this.$refs.xTable.getTableData().tableData
      this.$refs.xTable.clearValidate()
      let record = assign(this.dataTmp)
      if (!this.canInsert) {
        record = Object.assign(record, {
          ordersBuyerId: tableData[0].ordersBuyerId,
          ordersSellerId: tableData[0].ordersSellerId,
          orderNum: tableData[0].orderNum, //承运人订单号
          ordersSellerNum: tableData[0].ordersSellerNum,
          ordersBuyerNum: tableData[0].ordersBuyerNum,
          invoiceCompName: tableData[0].invoiceCompName, //开票单位
          invoiceTitle: tableData[0].invoiceTitle, //发票抬头
          goodsName: tableData[0].goodsName, //应税商品名称
          counts: tableData[0].counts, //应税商品数量
          unit: tableData[0].unit, //单位
          salesMan: tableData[0].salesMan,
          // taxRate: tableData[0].taxRate,
          rateManage: tableData[0].rateManage,
          orderRateDeduct: tableData[0].orderRateDeduct,
          orderRateDeductManage: tableData[0].orderRateDeductManage
        })
      }
      record.index = tableData.length + 1
      record.fileList = []
      record.fileUuidList = []
      this.$refs.xTable.insertAt(record, -1)
    },
    async removeEvent() {
      let checkboxRecords = this.$refs.xTable.getCheckboxRecords()
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: '没有选择'
        })
        return
      }
      if (!this.canInsert) {
        //不能全部删除
        if (checkboxRecords.length == this.$refs.xTable.getTableData().tableData.length) {
          this.$XModal.message({
            message: '不能全部删除,至少保留一条'
          })
          return
        }
      }
      let confirmRes = await this.$XModal.confirm(
        "删除后不可恢复",
        "是否删除？"
      );
      if (confirmRes == 'confirm') {
        this.$refs.xTable.removeCheckboxRow()
      }
    },
    copyEvent() {
      let checkboxRecords = this.$refs.xTable.getCheckboxRecords()
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: '没有选择'
        })
        return
      }

      this.$refs.xTable.insertAt(checkboxRecords, -1)
    },
    async validEvent() {
      const errMap = await this.$refs.xTable
        .validate()
        .catch((errMap) => errMap);
      return errMap ? false : true
    },
    async submitEvent() {
      this.isSubmit = true;
      let sts = await this.validEvent()
      if (!sts) {
        this.$XModal.message({
          status: "error",
          message: "校验不通过！"
        });
        return
      }
      let table = this.$refs.xTable.getTableData()

      if (table.tableData.length == 0) {
        this.$XModal.message({
          message: "请先添加发票"
        });
        return
      }
      let obj = {}
      let rows = []
      table.fullData.forEach(item => {
        let row = assign(item)
        if (row.laydays != null && row.laydays != '') {
          row.laydays = this.$utils.timestamp(this.$utils.toStringDate(row.laydays))
        }
        if (row.addTime != null && row.addTime != '') {
          row.addTime = this.$utils.timestamp(this.$utils.toStringDate(row.addTime))
        }
        if (row.deductTime != null && row.deductTime != '') {
          row.deductTime = this.$utils.timestamp(this.$utils.toStringDate(row.deductTime))
        }
        if (row.taxTotalAmount != null && row.taxTotalAmount != '') {
          row.amount = row.taxTotalAmount
        }
        row.compName = this.cate == 'Sales' ? row.invoiceCompName : row.invoiceTitle;
        row.ownName = row.compName;
        row.invoiceNum = row.invoiceNum.trim();
        rows.push(row)
      });
      obj.applyTime = this.$utils.timestamp(
        this.$utils.toStringDate(this.formData.applyTime)
      );
      obj.instanceName = this.formData.instanceName;
      obj.instanceNum = this.formData.instanceNum;
      obj.applyUserId = this.formData.applyUserId
      obj.leaderId = this.formData.leaderId
      obj.managerId = this.formData.managerId
      obj.reterenceId = this.formData.reterenceId
      obj.flowTempletId = this.flowTempletId
      obj.invoiceList = rows;
      let action = this.cate == 'Sales' ? 'saveFlowForInvoiceSeller' : 'saveFlowForInvoiceBuyer'

      showLoading()
      let res = await $api.flowInstance.request(action, obj)
      hideLoading()

      if (res.status == 1) {
        this.$XModal.message({
          status: "success",
          message: '提交成功'
        })
        this.tableData = []
        this.$emit('close')
      } else if (res.status == 0) {
        //检查部分失败的情况
        // let errorData = []
        // res.data.forEach(failItem => {
        //   errorData.push(assign(this.tableData[failItem.failArrayIndex]))
        // })
        // this.tableData = errorData
        showFailMsgList(res.data)
        // this.$XModal.message({ status: "success", message: res.data[0].failMsg })
      } else {
        if (!res.message) {
          res.message = '接口异常'
        }
        this.$XModal.message(res.message)
      }
      this.$emit('init')
    },
    footerCellClassName({
                          $rowIndex,
                          column,
                          columnIndex
                        }) {
      return 'footer-cell'
    },
    footerMethod({
                   columns,
                   data
                 }) {
      return invoiceFooter({
        columns,
        data,
        countRtnVo: null
      })
    },
    updateFooterEvent() {
      this.$refs.xTable.updateFooter()
    },
    calcMoney(row, field) {
      // row.counts = isNaN(row.counts) ? '' : row.counts
      // row.price = isNaN(row.price) ? '' : row.price
      if (row.counts !== '' && row.price !== '') {
        let priceAmount = Math.round(row.counts * row.price * 100) / 100;
        row.totalAmount = isNaN(parseInt(priceAmount)) ? '' : priceAmount;
        this.calcMoneyAll(row);
      } else {
        row.totalAmount = ''
      }
      this.updateFooterEvent()
    },
    calcMoneyAll(row) {
      // row.taxRate = isNaN(parseInt(row.taxRate)) ? '' : row.taxRate;
      // row.totalAmount = isNaN(parseInt(row.totalAmount)) ? '' : row.totalAmount;
      if (row.taxRate !== '' && row.totalAmount !== '') {
        row.taxAmount = Math.round(row.totalAmount * row.taxRate) / 100;
        this.calcMoneySecAll(row)
      } else {
        row.taxAmount = ''
      }
      this.updateFooterEvent()
    },
    calcMoneySecAll(row) {
      // row.taxAmount = isNaN(parseInt(row.taxAmount)) ? '' : row.taxAmount;
      // row.totalAmount = isNaN(parseInt(row.totalAmount)) ? '' : row.totalAmount;
      if (row.taxAmount !== '' && row.totalAmount !== '') {
        if(row.taxAmount !== null && row.totalAmount !== null){
          row.taxTotalAmount = Math.round((parseFloat(row.taxAmount) + parseFloat(row.totalAmount)) * 100) / 100;
        }
        this.calcMoneyTreAll(row)
      } else {
        row.taxTotalAmount = ''
      }
      this.updateFooterEvent()
    },
    calcMoneyTreAll(row) {
      let rate = '';
      if(this.cate === "Income"){
        rate = row.rateDeduct;
      }else {
        rate = row.rateManage;
        row.deductType = 1;
      }
      rate = isNaN(parseInt(rate)) ? '' : rate;

      if(!row.deductType){
        return
      }
      if (row.deductType === 1) {
        if (rate !== "" && row.taxTotalAmount !== "") {
          row.manageAmount = Math.round(row.taxTotalAmount * rate) / 100;
        }else {
          row.manageAmount = "";
        }
      }else {
        if (rate !== "") {
          row.manageAmount = Math.round(row.taxAmount * rate) / 100;
        }else{
          row.manageAmount = "";
        }
      }
      this.updateFooterEvent()
    },
    authCreate() {
      return this.cate == 'Sales' && this.isHavePermission('invoice:createInvoiceSeller') || this.cate == 'Income' && this.isHavePermission('invoice:createInvoiceBuyer')
    },
  },
};